import React from 'react';
import items from './navConfig';
import logo from '../../assets/imgs/logo.png';
import './Header.css';
import Dropdown from '../dropdown/Dropdown';
import NavItems from '../navItems/Items';
import { withRouter } from 'react-router-dom';


class Header extends React.Component {
  render() {
    return (
      <header>
        <div
          className="header-left"
          onClick={() => this.props.history.push("/")}
        >
          <div className="decoration"></div>
          
          <img src={logo} alt="logo" />
        </div>   

        <Dropdown items={items}/>

        <nav className="header-right">
          <NavItems items={items}/>
        </nav>  
      </header>
    )
  }
}

export default withRouter(Header);